import axios from 'axios'

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:4085/api'

const ictaApi = axios.create({ baseURL })

ictaApi.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('token')
		if (token) {
			config.headers!['x-token'] = token
		}

		return config
	},
	(error) => {
		Promise.reject(error)
	}
)

export default ictaApi
